import { Dialog, DialogContent, DialogActions, Button } from '@mui/material';
import { Snackbar } from '@mui/material';
import CustomSnackbar from '../../../Components/CustomSnackbar';
import React, { useState, useEffect } from 'react';
import { loadingDividerDataComponent } from '../../../LoadingData/LoadingDataComponents';
import { UpdateDividerDescription, UpdateDividerModel } from '../../../UpdateData/UpdateCommunications';
import { DELETE_DIVIDER_ID_API_URL } from '../../../OpticApiConfig';
import Select from 'react-select';
import { UpdateDividerKtvComponents, UpdateDividerPonComponents } from '../../../UpdateData/UpdateStatusComponent';


const customStyles = {
  control: base => ({
    ...base,
    background: '#4b4b4b',
    borderRadius: '5px',
    fontSize: '14px',
    border: '1px solid #ffffff',
    marginBottom: '5px',
    marginTop: '10px',
    width: '280px'
  }),
  singleValue: base => ({
    ...base,
    color: '#ffffff', 
    
  }),
  input: base => ({
    ...base,
    color: '#ffffff', 
  }),
  menu: base => ({
    ...base,
    background: '#4b4b4b',
    color: '#ececec', 
    fontSize: '14px',
    width: '280px'
  }),
  option: (base, { isFocused }) => ({
    ...base,
    backgroundColor: isFocused ? '#bdbdbd' : 'transparent', 
    color: isFocused ? '#000000' : '#ececec', 
  }),
};

const DiviredNodeCantonEditingDialog = ({ open, onClose, content, cantonRefresh}) => {

  const { showSnackbar, snackbarOpen, handleCloseSnackbar, snackbarMessage, snackbarClass } = CustomSnackbar();
  const [dividerData, setDividerData] = useState([]);
  const [dividerId, setDividerId] = useState("");
  const token = localStorage.getItem('token');
  const [inputValue, setInputValue] = useState("");
  const [statusChange, setStatusChange] = useState(false);
  const [textComment, setTextComment] = useState(content.description || "");
  const [statusPon, setStatusPon] = useState(false); 
  const [statusKtv, setStatusKtv] = useState(false); 

   useEffect(() => {
          setStatusPon(content.ponDivider === 1);
          setStatusKtv(content.ktvDivider === 1);
  }, [ content.ktvDivider, content.ponDivider]);

// Обновляем состояние при изменении `content`
useEffect(() => {
  setTextComment(content.description || "");
}, [content.description]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [dividerData, rankComponentData] = await Promise.all([
          loadingDividerDataComponent(),
          //loadingRankComponentDataComponent(),
        ]);
        setDividerData(dividerData);
       // setRankComponentData(rankComponentData);
      } catch (error) {
        // console.error("Error in fetchData:", error);
      }
    };
    fetchData();
  }, []);

  
  const handleCloseDialogs = () => {    
    cantonRefresh();
       onClose(); 
  };

   const handlePonCheckboxChange = () => {
          setStatusPon(!statusPon);   
          if(!statusPon){
            UpdateDividerPonComponents(content.id, 1, showSnackbar);
          }else{
            UpdateDividerPonComponents(content.id, 0, showSnackbar);
          }
          
        };
      
        const handleKtvCheckboxChange = () => {
          setStatusKtv(!statusKtv);   
          if(!statusKtv){
            UpdateDividerKtvComponents(content.id, 1, showSnackbar);
          }else{
            UpdateDividerKtvComponents(content.id, 0, showSnackbar);
          } 
        };


   const deleteDivider = async () => {
  
          if (!token) {
              showSnackbar('Ошибка! Токен не найден', 'snackbarWarning');
              return;
          }

          try {
              let apiDivider = `${DELETE_DIVIDER_ID_API_URL}?dividerId=${content.id}`;

              const response = await fetch(apiDivider, { 
                  method: 'DELETE',
                  headers: {
                      'Content-Type': 'application/json',
                      'Authorization': `Bearer ${token}` 
                  }
              });
  
              if (response.ok) {
                  showSnackbar('Компонент успешно удален', 'snackbarWarning');
                  setDividerData([]);
                  setDividerId("");
                  cantonRefresh();
                  onClose();
              } else {
                  showSnackbar('Ошибка удаления!', 'snackbarWarning');
              }
          } catch (error) {
              showSnackbar('Произошла ошибка!', 'snackbarWarning');
          }  
      };


      const handleDescriptionChange = (event) => {
        const newText = event.target.value;
        setTextComment(newText);
    
        if (newText !== content.comment) {
            setStatusChange(true);
        } else {
            setStatusChange(false);
        }
     };

  // const handleChangeDividerSelect = (event) => {
  //   const selectedDivider = event.target.value;
  //   if (selectedDivider === "") {
  //     setDividerId("");
  //   } else {
  //     const selectedDivider2 = dividerData.find(divired => 
  //       `${divired.id}` === selectedDivider
  //     );
  //     if (selectedDivider2) {
  //       setDividerId(selectedDivider2.id);
  //     }
  //   }
  // };

  const handleChangeDividerSelect = (selectedOption) => {
    if (!selectedOption) {
      setDividerId(""); // Если пользователь очистил выбор, сбрасываем ID
      return;
    }
  
    const selectedDivider = selectedOption.value; // `react-select` передает объект { value, label }
    
    const selectedDividerData = dividerData.find(divider => `${divider.id}` === `${selectedDivider}`);
    
    if (selectedDividerData) {
      setDividerId(selectedDividerData.id);
    }
  };

  const updateModel = () => {
  
    if (dividerId === "") {
      showSnackbar('Нет нужды в записи, делитель без изменений!', 'snackbarOk');
    } else {
      UpdateDividerModel(content.id, dividerId, showSnackbar );
    } 
  };

   const updateDescription = () => {
      if (statusChange) {
        UpdateDividerDescription(content.id, textComment, showSnackbar);
      } else {
        showSnackbar('Нет нужды в записи, текст без изменений!', 'snackbarOk');
      }
    };

  const options = dividerData.map(divider => ({
    value: `${divider.id}`,
    label: divider.model,
    group: divider.polishingId === 1 ? "UPC" : "APC",
  }));

  // Группировка опций
  const groupedOptions = [
    {
      label: "UPC",
      options: options.filter(option => option.group === "UPC"),
    },
    {
      label: "APC",
      options: options.filter(option => option.group === "APC"),
    },
  ];

    return (
  
    <Dialog open={open} className="dialogStyle" >
    
      <DialogContent style={{height: 'auto'}}>
     
      <img 
        src={content.polishingId === 1 ? "./divider_upc2.png" : "./divider_apc2.png"} 
        width="30" 
        height="30" 
        style={{ marginRight: "5px" }} 
        alt="Divider"
      />
       
      <label style={{ color: '#dfab01', fontSize: '20px', fontFamily:'unset'}}>Редактирование делителя</label>
      <hr className='horizontalLineDialog'/>
      <label style={{ color: '#292929', fontWeight: 'bold'}}>ID: <span style={{ color: '#bebebe' }}>{content.id}</span></label>
      <hr className='horizontalLineDialog'/>
      <label style={{ color: '#292929', fontWeight: 'bold'}}>Признак:</label>

      <label style={{ color: '#292929', fontWeight: 'bold', marginLeft:'10px'}}>PON:</label>
        <input
          type="checkbox"
          checked={statusPon}
          onChange={handlePonCheckboxChange}
          style={{ marginLeft: '10px' }}
        />      

       <label style={{ color: '#292929', fontWeight: 'bold', marginLeft:'10px'}}>KTV:</label>
          <input
            type="checkbox"
            checked={statusKtv}
            onChange={handleKtvCheckboxChange}
            style={{ marginLeft: '10px' }}
          />      
      
      <hr className="horizontalLineDialog2" style={{marginTop: "10px"}}/> 
    
               <Select
                  className="selectSearchDrawer"
                  options={groupedOptions}
                  inputValue={inputValue}
                  styles={customStyles}
                  value={options.find(option => `${option.value}` === `${content.dividerId}`) || null} 
                  onInputChange={value => setInputValue(value)} 
                  onChange={handleChangeDividerSelect}
                  placeholder="Выберите делитель"
                  isClearable
                />
      <button onClick={updateModel} class='buttonIsSaveDialog2' style={{fontSize: '14px', paddingTop: '3px', paddingBottom: '3px'}}>Сохранить</button>
      <hr className="horizontalLineDialog2" style={{marginTop: "10px"}}/>

      <label style={{ color: '#292929', fontWeight: 'bold'}}>Коммент:</label>
      <textarea
          className="textAreaEditingModal"
          value={textComment}       
          onChange={handleDescriptionChange} 
        />
         <br/>
         <button  class='buttonIsSaveDialog2' onClick={updateDescription} style={{fontSize: '14px', paddingTop: '3px', paddingBottom: '3px'}}>Сохранить</button>
         <br/> <br/>
       <hr className='horizontalLineDialog'/>
      
      <button onClick={deleteDivider} class='buttonIsDeleteModal2' style={{marginLeft:"0px"}}>Удалить</button>
      

      </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialogs} class='buttonIsHideDrawer23'>
            Закрыть
          </Button>
        </DialogActions>


       {/* Snackbar */}
       <Snackbar
         anchorOrigin={{
         vertical: 'bottom',
         horizontal: 'left',
         }}
         open={snackbarOpen}
         autoHideDuration={3000}
         onClose={handleCloseSnackbar}
         message={snackbarMessage}
         ContentProps={{
          style: {
            color: snackbarClass === 'snackbarOk' ? '#ffda62' : '#202020'
          }
        }}
      />

      
    </Dialog>
  );
}

export default DiviredNodeCantonEditingDialog;